import { useQuery } from '@tanstack/react-query';
import { IKeepInTouchSystemJob } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'keepInTouch/jobs/<jobId>';

export function useKeepInTouchJob({ jobId, enabled = true }: { jobId: string; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!jobId,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchSystemJob>(
				`keepInTouch/jobs/${encodeURIComponent(jobId)}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, jobId],
	});
}

export const invalidateKeepInTouchJob = (jobId: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, jobId] });
};
